export const PromisifyGetModel: (model: any) => (params: any) => Promise<unknown> = (
  model: any,
): ((params: any) => Promise<unknown>) => {
  const create = new model();
  return (params: any): Promise<unknown> =>
    new Promise(
      (
        resolve: (value: PromiseLike<unknown> | unknown) => void,
        reject: (reason?: any) => void,
      ): void => {
        const query: string = JSON.stringify({ data: params });
        create.fetch({
          data: params,
          success: (_: any, response: any): void => resolve(response),
          error: (_: any, response: any, options: any): void => reject({ response, options }),
        });
      },
    );
};

export const PromisifyPostModel: (model: any) => (body: any) => Promise<unknown> = (
  model: any,
): ((body: any) => Promise<unknown>) => {
  return (body: any): Promise<unknown> =>
    new Promise(
      (
        resolve: (value: PromiseLike<unknown> | unknown) => void,
        reject: (reason?: any) => void,
      ): void => {
        // Overriding save feature of backbone
        const create: any = new model();
        create.save(body, {
          type: "POST",
          success: (_: any, response: any): void => resolve(response),
          error: (_: any, response: any, options: any): void => reject({ response, options }),
        });
      },
    );
};
